<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="슥삭" />
            <Navbar></Navbar>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container fluid class="px-5" style="min-height:1200px">
                            <div v-if="!errMsg">
                                <v-row class="mt-5">
                                    <span class="col-12 rem-2 text-left">후기 상세 조회(모바일) - 관리자 전용</span>
                                </v-row>
                                <v-row v-if="clubDetail" class="mt-5">
                                    <span class="col-12 rem-1 text-left">활동명: {{clubDetail.clubName}}</span>
                                    <span v-if="clubDetail.clubType == 0" class="col-12 rem-1 text-left">활동타입: 연합동아리</span>
                                    <span v-else-if="clubDetail.clubType == 1" class="col-12 rem-1 text-left">활동타입: 교내동아리</span>
                                    <span v-else-if="clubDetail.clubType == 2" class="col-12 rem-1 text-left">활동타입: 대외활동</span>
                                    <span v-else class="col-12 rem-1 text-left">활동타입: 인턴</span>
                                    <span class="col-12 rem-1 text-left">대학교/활동지역: {{clubDetail.univOrLocation}}</span>
                                    <span class="col-12 rem-1 text-left">카테고리: {{clubDetail.categoryList}}</span>
                                </v-row>
                                <v-row class="mt-5">
                                    <span class="col-12 rem-2 text-left">사용자 후기 리스트</span>
                                    <v-simple-table>
                                        <thead>
                                            <th>닉네임</th>
                                            <th>활동시작날짜</th>
                                            <th>활동마감날짜</th>
                                            <th>score0</th>
                                            <th>score1</th>
                                            <th>score2</th>
                                            <th>score3</th>
                                            <th>score4</th>
                                            <th>작성날짜</th>
                                            <th>삭제</th>
                                            <th>승인</th>
                                        </thead>
                                        <tbody v-for="(clubPost, index) in clubPosts">
                                                <tr>
                                                    <td class="text-left">{{clubPost.userNickname}}</td>
                                                    <td class="text-left">{{clubPost.clubStartDate}}</td>
                                                    <td class="text-left">{{clubPost.clubEndDate}}</td>
                                                    <td class="text-left">{{clubPost.score0}}</td>
                                                    <td class="text-left">{{clubPost.score1}}</td>
                                                    <td class="text-left">{{clubPost.score2}}</td>
                                                    <td class="text-left">{{clubPost.score3}}</td>
                                                    <td class="text-left">{{clubPost.score4}}</td>
                                                    <td class="text-left">{{clubPost.regDate}}</td>
                                                    <td>
                                                        <v-dialog
                                                            v-model="deleteClubPostDialog[index]"
                                                            max-width="290"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-row>
                                                                    <v-btn class="bg-grey text-white border-rounded30 mx-auto" style="inline-block" :height="30" v-on="on">
                                                                        <span>삭제</span>
                                                                    </v-btn>
                                                                </v-row>
                                                            </template>
                                                            <v-card>
                                                                <v-card-title>주의</v-card-title>
                                                                <v-card-text>
                                                                    <span>정말 삭제하시겠습니까?</span>
                                                                </v-card-text>
                                                                <v-card-actions>
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn color="text-main" text @click="deleteClubPost(clubPost.clubPostIdx)">예</v-btn>
                                                                    <v-btn color="text-grey-1" text @click="deleteClubPostDialog.splice(index, 1, false)">아니요</v-btn>
                                                                </v-card-actions>
                                                            </v-card>
                                                        </v-dialog>
                                                    </td>
                                                    <td>
                                                        <v-dialog
                                                            v-model="adminAcceptDialog[index]"
                                                            max-width="290"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-row>
                                                                    <v-btn :class="clubPost.adminAccept == 0 ? 'bg-main text-white border-rounded30 mx-auto' : 'bg-grey text-white border-rounded30 mx-auto'" style="inline-block" :height="30" v-on="on">
                                                                        <span v-if="clubPost.adminAccept == 0">승인</span>
                                                                        <span v-else>승인취소</span>
                                                                    </v-btn>
                                                                </v-row>
                                                            </template>
                                                            <v-card>
                                                                <v-card-title>주의</v-card-title>
                                                                <v-card-text>
                                                                    <span class="mt-5" v-if="clubPost.adminAccept == 0">정말 승인하시겠습니까?</span>
                                                                    <span class="mt-5" v-else>정말 승인 취소하시겠습니까?</span>
                                                                </v-card-text>
                                                                <v-card-actions>
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn color="text-main" text @click="adminAcceptClubPost(clubPost.clubPostIdx, clubPost.adminAccept, index)">예</v-btn>
                                                                    <v-btn color="text-grey-1" text @click="adminAcceptDialog.splice(index, 1, false)">아니요</v-btn>
                                                                </v-card-actions>
                                                            </v-card>
                                                        </v-dialog>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="text-left">상세내용</td>
                                                    <td class="text-left" colspan="10">
                                                        한줄평: {{clubPost.oneLine}}<br/><br/>
                                                        장점: {{clubPost.advantage}}<br/><br/>
                                                        단점: {{clubPost.disadvantage}}<br/><br/>
                                                        꿀팁: {{clubPost.honeyTip}}
                                                        <span v-if="clubPost.fieldName"><br/><br/>분야: {{clubPost.fieldName}}</span>
                                                    </td>
                                                </tr>
                                            
                                        </tbody>
                                    </v-simple-table>
                                </v-row>

                                <v-row class="mt-5">
                                    <span class="col-12 rem-2 text-left">블로그 후기 리스트</span>
                                    <v-simple-table>
                                        <thead>
                                            <th>주소</th>
                                            <th>게시날짜</th>
                                            <th>작성자</th>
                                            <th>제목</th>
                                            <th>내용</th>
                                            <th>등록날짜</th>
                                            <th>이미지</th>
                                            <th>삭제</th>
                                        </thead>
                                        <tbody v-for="(clubBlog, index) in clubBlogs">
                                                <tr>
                                                    <td class="text-left"><a :href="clubBlog.blogUrl" target="_blank">{{clubBlog.blogUrl}}</a></td>
                                                    <td class="text-left">{{clubBlog.blogRegDate}}</td>
                                                    <td class="text-left">{{clubBlog.blogNickname}}</td>
                                                    <td class="text-left">{{clubBlog.blogTitle}}</td>
                                                    <td class="text-left">{{clubBlog.blogDescription}}</td>
                                                    <td class="text-left">{{clubBlog.regDate}}</td>
                                                    <td class="text-left">
                                                        <a :href="clubBlog.blogImageUrl" target="_blank">보기</a>
                                                    </td>
                                                    <td>
                                                        <v-dialog
                                                            v-model="deleteClubBlogDialog[index]"
                                                            max-width="290"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-row>
                                                                    <v-btn class="bg-grey text-white border-rounded30 mx-auto" style="inline-block" :height="30" v-on="on">
                                                                        <span>삭제</span>
                                                                    </v-btn>
                                                                </v-row>
                                                            </template>
                                                            <v-card>
                                                                <v-card-title>주의</v-card-title>
                                                                <v-card-text>
                                                                    <span>정말 삭제하시겠습니까?</span>
                                                                </v-card-text>
                                                                <v-card-actions>
                                                                    <v-spacer></v-spacer>
                                                                    <v-btn color="text-main" text @click="deleteClubBlog(clubBlog.clubBlogIdx)">예</v-btn>
                                                                    <v-btn color="text-grey-1" text @click="deleteClubBlogDialog.splice(index, 1, false)">아니요</v-btn>
                                                                </v-card-actions>
                                                            </v-card>
                                                        </v-dialog>    
                                                    </td>
                                                </tr>
                                            
                                        </tbody>
                                    </v-simple-table>
                                </v-row>
                                <v-row class="mt-5 mb-5">
                                    <span class="col-12 rem-2 text-left">블로그 후기 등록</span>
                                    <v-text-field label="네이버 블로그 주소" outlined dense hint="예시) https://blog.naver.com/gumgim95/221972032831" class="mt-2 col-12 col-sm-6" v-model="blogUrl"></v-text-field>
                                    <v-btn class="ml-2 mt-2 bg-main-dark text-white" v-on:click="registerBlogPost()">등록</v-btn>
                                </v-row>
                            </div>

                            <v-row v-if="errMsg != null" class="mt-5">
                                <span class="col-12 display-1 text-left">{{errMsg}}</span>
                                
                            </v-row>
                            
                            

                        </v-container>
                        <Footer></Footer>
                    </v-flex>
                </v-layout>
    
            </v-container>

    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()

        this.clubIdx = this.$route.params.clubIdx
        this.getClubDetail()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 2,
            window: {
                width: 0,
                height: 0
            },
            ismobile: false,

            drawer: false,
            group: null,

            errMsg: null,

            clubIdx: null,
            clubDetail: null,
            clubPosts: null,
            clubBlogs: null,

            blogUrl: '',

            adminAcceptDialog: [],
            deleteClubPostDialog: [],
            deleteClubBlogDialog: [],
        }
    },
    computed:{
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        },
        getClubDetail(){
            this.$http.get(`/api/clubs/${this.clubIdx}`)
                .then((response) => {
                    if(response.data.status == 200){
                        this.clubDetail = response.data.data.clubDetail;
                        this.clubPosts = response.data.data.clubPosts;
                        this.clubBlogs = response.data.data.clubBlogs;

                        this.adminAcceptDialog = []
                        this.deleteClubPostDialog = []
                        this.deleteClubBlogDialog = []
                        for(var i = 0; i < this.clubPosts.length; i++){
                            this.adminAcceptDialog.push(false)
                            this.deleteClubPostDialog.push(false)
                        }
                        for(var i = 0; i < this.clubBlogs.length; i++){
                            this.deleteClubBlogDialog.push(false)
                        }
                    }
                    else{
                        this.errMsg = '로그인을 해주세요.'
                    }
                })
                .catch(error => {
                    console.log('server error', error)
                })
        },
        registerBlogPost(){
            if(this.blogUrl.trim().length <= 1){
                alert('블로그 주소를 제대로 입력해주세요.')
            }
            let postQueryString = 'http://ssgsag-alb-2141317761.ap-northeast-2.elb.amazonaws.com/club/' + this.clubIdx + '/blog?blogUrl=' + this.blogUrl.trim()
            this.$http.post(postQueryString)
                .then((response) => {
                    console.log(response)
                    if(response.data.status == 200){
                        alert('블로그 후기 등록 완료')
                        window.location.reload()
                    }
                    else{
                        alert('올바른 블로그 주소를 입력해주세요.')
                    }
                })
        },
        adminAcceptClubPost(clubPostIdx, adminType, index){
            this.adminAcceptDialog.splice(index, 1, false)
            let updateAdmin;
            if(adminType == 0){
                updateAdmin = 1
            }
            else{
                updateAdmin = 0
            }
            this.$http.post(`/api/clubs/post/adminAccept/${clubPostIdx}?adminType=${updateAdmin}`)
            .then( response => {
                if(response.data.status == 204){
                    window.location.reload()
                } else {
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            })
            .catch( error => {
                console.log('failed', error)
            })
        },
        deleteClubPost(clubPostIdx){
            this.$http.delete(`/api/clubs/post/${clubPostIdx}`)
            .then( response => {
                if(response.data.status == 200){
                    window.location.href='/admin/clubs'
                } else {
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            })
            .catch( error => {
                console.log('failed', error)
            })
        },
        deleteClubBlog(clubBlogIdx){
            this.$http.delete(`/api/clubs/blog/${clubBlogIdx}`)
            .then( response => {
                if(response.data.status == 200){
                    window.location.reload()
                } else {
                    alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                    this.$store.dispatch('postLogout')
                }
            })
            .catch( error => {
                console.log('failed', error)
            })
        },
    }
}
</script>

<style lang="css">
</style>


// WEBPACK FOOTER //
// src/pages/ClubDetail.vue